import { numberFormatter } from '../utils/helpers'
import { roles } from './permissionsConfig'
import UserIcon from '../images/icons/user.svg'
import InstitutionIcon from '../images/icons/institution.svg'
import FormIcon from '../images/icons/form.svg'
import AnswerIcon from '../images/icons/answer.svg'
import FormCreatedIcon from '../images/icons/form-created.svg'
import TimerIcon from '../images/icons/timer_icon.svg'
import { downloadTypes } from '../constants/statistics'

const linearChartOption = ({ hTitle, vTitle }) => ({
  curveType: 'function',
  legend: { position: 'bottom' },
  hAxis: {
    title: hTitle,
    titleTextStyle: {
      bold: true
    }
  },
  vAxis: {
    title: vTitle,
    titleTextStyle: {
      bold: true
    }
  },
  pointSize: 9,
  lineWidth: 2
})

const donutChartOptions = ({ title }) => ({
  title,
  is3D: true,
  pieStartAngle: 100,
  sliceVisibilityThreshold: 0,
  legend: {
    position: 'right',
    alignment: 'center',
    textStyle: {
      color: '#000',
      fontSize: 16
    }
  }
})

const detailByType = {
  LineChart: {
    name: 'Gráfico lineal',
    options: linearChartOption
  },
  BarChart: {
    name: 'Gráfico de barras',
    options: linearChartOption
  },
  PieChart: {
    name: 'Gráfico circular',
    options: donutChartOptions
  }
}

const downloadOptions = [
  { id: downloadTypes.picture, label: 'Gráfico' },
  { id: downloadTypes.excel, label: 'Documento de Excel con data detallada del indicador' }
]

const downloadChart = (chartUri, title) => {
  if (chartUri) {
    const downloadLink = document.createElement('a')
    downloadLink.href = chartUri
    downloadLink.download = title.split(' ').join('_') + '.png'
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }
}

const getCardValues = (values, role) => {
  return [
    {
      icon: UserIcon,
      title: 'Usuarios registrados',
      value: numberFormatter.quantity(values.total_users),
      indicator: 'users',
      visibleRoles: [roles.admin, roles.coordinator, roles.branch_coordinator]
    },
    {
      icon: InstitutionIcon,
      title: 'Entidades registradas',
      value: numberFormatter.quantity(values.total_institutions),
      indicator: 'institutions',
      visibleRoles: [roles.admin]
    },
    {
      icon: FormIcon,
      title: 'Formularios creados',
      value: numberFormatter.quantity(values.total_forms),
      indicator: 'forms',
      visibleRoles: [roles.admin, roles.coordinator, roles.branch_coordinator, roles.collaborator]
    },
    {
      icon: AnswerIcon,
      title: 'Respuestas recibidas',
      value: numberFormatter.quantity(values.total_answers),
      indicator: 'answers',
      visibleRoles: [roles.admin, roles.coordinator, roles.branch_coordinator, roles.collaborator]
    },
    {
      icon: FormCreatedIcon,
      title: 'Solicitudes atendidas',
      value: numberFormatter.quantity(values.total_attended),
      indicator: 'receivedRequests',
      visibleRoles: [roles.admin, roles.coordinator, roles.branch_coordinator, roles.collaborator]
    },
    {
      icon: TimerIcon,
      title: 'Promedio de atención',
      value: `${values.average_days_to_handle} días`,
      indicator: 'attendedRequests',
      visibleRoles: [roles.admin, roles.coordinator, roles.branch_coordinator, roles.collaborator]
    }
  ].filter(card => card.value && card.visibleRoles.includes(role))
}

export { downloadOptions, detailByType, downloadChart, getCardValues }
